import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaBars, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import dheeram from "../../Assets/dheeram.jpg";

const menuItems = [
  { name: "Home", path: "/" },
  { name: "About", path: "/AboutUs" },
  { name: "What We Do", path: "/WhatWeDo" },
  { name: "Product", path: "/Category" },
  { name: "Contact Us", path: "/Contact" },
  
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const sidebarVariants = {
    hidden: { x: "-100%" },
    visible: {
      x: 0,
      transition: {
        type: "tween",
        duration: 0.3,
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
    exit: { x: "-100%", transition: { duration: 0.3 } },
  };

  const itemVariants = {
    hidden: { x: -20, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.3 } },
  };

  return (
    <div className="w-full flex justify-center ">
      <motion.nav
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="fixed top-0 z-50 backdrop-blur-lg bg-[#311C0E] shadow-xl    px-4 py-4 w-full flex items-center justify-between"
      >
        
        <div className="xl:hidden mr-4">
          <FaBars
            size={24}
            onClick={() => setMobileMenuOpen(true)}
            className="cursor-pointer text-white"
          />
        </div>

       
        <div className="flex items-center gap-2 flex-1 justify-center xl:justify-start">
          <img src={dheeram} alt="Logo" className="h-10 rounded drop-shadow" />
         
          <h2
            className="
              text-white
              font-bold            
              text-base            
              sm:text-lg        
              xl:font-extrabold   
              xl:text-xl          
            "
          >
            DHEERAM APPAREL CREATIONS
          </h2>
        </div>

       
        <ul className="hidden xl:flex gap-10 text-white font-medium">
          {menuItems.map((item) => (
            <li
              key={item.name}
              className="cursor-pointer hover:text-red-600"
              onClick={() => navigate(item.path)}
            >
              {item.name}
            </li>
          ))}
        </ul>
      </motion.nav>

     
      <AnimatePresence>
        {mobileMenuOpen && (
          <>
          
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="fixed inset-0 bg-black z-40"
              onClick={() => setMobileMenuOpen(false)}
            ></motion.div>

            
            <motion.div
              variants={sidebarVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="fixed top-0 left-0 w-72 max-w-[80%] h-full bg-[#40210F] z-[9999] flex flex-col p-6 shadow-xl"
            >
            
              <div className="flex justify-end mb-6">
                <FaTimes
                  size={28}
                  onClick={() => setMobileMenuOpen(false)}
                  className="cursor-pointer text-white hover:text-red-600 transition"
                />
              </div>

             
              <ul className="flex flex-col text-white font-semibold">
                {menuItems.map((item, idx) => (
                  <motion.li
                    key={item.name}
                    variants={itemVariants}
                    className="cursor-pointer px-4 py-3 rounded hover:bg-[#55321A] hover:text-red-600 transition relative"
                    onClick={() => {
                      navigate(item.path);
                      setMobileMenuOpen(false);
                    }}
                  >
                    {item.name}
                    {idx !== menuItems.length - 1 && (
                      <div className="absolute bottom-0 left-4 right-4 border-t border-[#311C0E]"></div>
                    )}
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Header;
